/*
runtime.js
 ├─ mount(el)      → el.dataset.mount 읽고 모듈 init()
 ├─ unmount(el)    → destroy() 실행
 ├─ bootstrap(root)→ root 아래 모든 data-mount 처리
 └─ 이벤트 바인딩
     ├─ DOMContentLoaded → 전체 init
     ├─ shopify:section:load → 해당 섹션 init
     └─ shopify:section:unload → 해당 섹션 destroy
*/
(function () {
    const mounts = new WeakMap();   // WeakMap - DOM 노드가 사라지면 자동으로 GC(가비지 컬렉션) → 메모리 누수 방지.

    // 모듈 등록 함수
    function mount(el) {
        const key = el.dataset.mount;
        if (!key || mounts.has(el)) return; // 중복 방지 (키 x , 이미 mount 된 경우)

        const factory = window.App?.modules?.[key];
        if (!factory) return;

        const inst = factory(el);
        inst.init?.();
        mounts.set(el, inst);
        console.log("✅ 등록된 모듈 확인 = ", mounts)
    }

    // 모듈 제거 함수
    function unmount(el) {
        const inst = mounts.get(el);
        if (inst) {
        inst.destroy?.();
        mounts.delete(el);
        }
    }

    // 등록된 모듈 실행
    function bootstrap(root = document) {
        root.querySelectorAll("[data-mount]").forEach(mount);
    }

    // Shopify Theme Editor 대응
    document.addEventListener("shopify:section:load", e => bootstrap(e.target));
    document.addEventListener("shopify:section:unload", e => unmount(e.target));

    // 최초 실행
    document.addEventListener("DOMContentLoaded", () => bootstrap());

    // 전역 네임스페이스 확보
    window.App = window.App || {};
    window.App.modules = window.App.modules || {};
    window.App.runtime = { bootstrap, mount, unmount };
})();

/*
[HTML DOM Tree]
    |
    ├─ <div data-mount="banner-slider"> → key(el)
    |       └─ WeakMap entry: el → instance
    |
    └─ <div data-mount="product-gallery"> → key(el)
            └─ WeakMap entry: el → instance

(섹션 제거)
    ↓
해당 div 사라짐 → key(el) 참조 끊김 → WeakMap entry 자동 GC
*/